import type {ConnectElementConfig} from '../ConnectElementList';

export const treasuryActivationModuleOnboardingRequiredParameter =
  'onboarding-required' as const;
export const treasuryActivationModuleLayoutParameter = 'layout' as const;

export const TreasuryActivationModuleConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryActivationModule" */
      '../../../components/MoneyManagement/TreasuryActivationModule/TreasuryActivationModule'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  htmlAttributes: {
    [treasuryActivationModuleLayoutParameter]: {
      isInternal: true,
    },
    [treasuryActivationModuleOnboardingRequiredParameter]: {
      isInternal: true,
    },
  },
  htmlEvents: ['close'],
  customHtmlElementMethods: {
    setLayout: {
      type: 'AttributeSettingMethod',
      attribute: treasuryActivationModuleLayoutParameter,
      isInternal: true,
      description:
        'Sets the layout to "horizontal" or "vertical". Defaults to "vertical".',
    },
    setOnClose: {
      type: 'EventListenerMethod',
      event: 'close',
      isInternal: true,
      description: 'Called when the Treasury entry modal is closed.',
    },
    setOnboardingRequired: {
      type: 'AttributeSettingMethod',
      attribute: treasuryActivationModuleOnboardingRequiredParameter,
      isInternal: true,
      description:
        'Sets whether Treasury onboarding is required. The module is hidden otherwise.',
    },
  },
  description:
    'Module to prompt for needed step-up compliance actions or to promote a new feature.',
  friendlyName: 'Treasury Activation Module',
};
